import type { DateView } from "@mui/x-date-pickers-pro";
import type { ReportingPeriod } from "@entrilia/shared/api/dataCollectionTypes";
import { getReportingPeriodDateFormat } from "@entrilia/shared/components/dataCollection/dataCollectionUtils";
import { formatDate } from "@entrilia/shared/utilities/dateUtils";
import { reportingPeriodCaptionsMap } from "@entrilia/shared/utilities/enumCaptions";
import type { DataCollectionRequestTemplateVersion } from "../../../../../api/types/dataCollectionTypes";
import type { ObjectAccessCategory } from "../../../../../api/types/objectTypes";
import { dataCollectionRequestAuditoryCaptionsMap } from "../../../../../utilities/enumCaptions";
import { getDataRequestTemplateCategoryName } from "../dataRequestHelper";

export const getTemplateSettingsProperties = (
  template: DataCollectionRequestTemplateVersion | undefined,
  categories: ObjectAccessCategory[]
): Array<[string, string]> => [
  ["Period", template?.reportingPeriod ? reportingPeriodCaptionsMap[template.reportingPeriod] : ""],
  [
    "Recipient Type",
    template?.auditory ? (dataCollectionRequestAuditoryCaptionsMap[template.auditory] ?? template.auditory) : "",
  ],
  ["Category", template ? getDataRequestTemplateCategoryName(template, categories) : ""],
  ["Companies", template?.recipientObjectIds.length.toLocaleString() ?? ""],
];

export const reportingDatePickerViewsMap: Record<ReportingPeriod, DateView[]> = {
  Month: ["year", "month"],
  Quarter: ["year", "month"],
  Year: ["year"],
  LastTwelveMonths: ["year", "month"],
};

export const getDefaultDataRequestName = (
  template: DataCollectionRequestTemplateVersion | undefined,
  reportingDate: Date | null
) => {
  if (!template || !reportingDate) {
    return "";
  }

  return `${template.name} - ${formatDate(reportingDate, getReportingPeriodDateFormat(template.reportingPeriod))}`;
};
